export const SMARTLIST_TAB = {
  type: "smartlist",
  label: "smartlist",
  value: 0,
} as const;

export const MY_LIST_TAB = {
  type: "my_list",
  label: "myList",
  value: 1,
} as const;

export const RESUME_TAB = {
  type: "resume",
  label: "resume",
  value: 2,
} as const;

export const USER_RECOMMENDATION_TAB = {
  type: "user_recommendation",
  label: "user_recommendation",
  value: 3,
} as const;

export const PURCHASE_TAB = {
  type: "purchase",
  label: "purchase",
  value: 4,
} as const;

export const NOW_TAB = {
  type: "now",
  label: "now",
  value: 5,
} as const;

export const MOST_VIEWED_TAB = {
  type: "mostViewed",
  label: "mostViewed",
  value: 6,
} as const;

export type SmartlistDataSourceTab =
  | typeof SMARTLIST_TAB
  | typeof MY_LIST_TAB
  | typeof RESUME_TAB
  | typeof USER_RECOMMENDATION_TAB
  | typeof PURCHASE_TAB
  | typeof NOW_TAB
  | typeof MOST_VIEWED_TAB;
